import { render, staticRenderFns } from "./TraderInfoPopup.vue?vue&type=template&id=2f1d603a&"
import script from "./TraderInfoPopup.vue?vue&type=script&lang=js&"
export * from "./TraderInfoPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports